import { AxiosMode } from '@/axiosModel';
import type { ApiResponse } from '@/axiosModel';

export interface BalanceRecord {
  id?: number;
  type?: number;
  total?: number;
  balance: number;
  expire_time?: number;
  msg?: string;
}

export interface BalanceInfo {
  balance: number;
  list: BalanceRecord[];
}

export interface CoinGiveStatus {
  status: number;
}

export interface PointConsumeListParams {
  page?: number;
  pageSize?: number;
  pagesize?: number;
}

export interface PointConsumeRecord {
  id?: string | number;
  user_id?: number | string;
  object_type?: number | string;
  object_id?: string | number;
  type?: number | string;
  total_number?: number | string;
  number?: number | string;
  create_time?: number | string;
  description?: string;
}

export interface PointConsumeListResult {
  list: PointConsumeRecord[];
  total: number;
  currency: string;
  page: number;
  pageSize: number;
}

interface BackendPointConsumeListResult {
  list?: PointConsumeRecord[];
  total?: number;
  currency?: string;
  page?: number;
  pageSize?: number;
  pagesize?: number;
}

const apis = new AxiosMode();
const COIN_API_BASE = `${AxiosMode.API_HOST}/api/coin`;
const AIPICTUREBOOK_API_BASE = `${AxiosMode.API_HOST}/api/aipicturebook`;
const DEFAULT_POINT_CONSUME_PAGE = 1;
const DEFAULT_POINT_CONSUME_PAGE_SIZE = 20;

export async function fetchBalance(): Promise<BalanceInfo> {
  const { req } = apis.post({
    postData: {},
    remotePath: `${COIN_API_BASE}/get-balance`
  });
  const res = (await req) as ApiResponse<BalanceInfo>;

  return {
    balance: Number(res.data?.balance ?? 0) || 0,
    list: Array.isArray(res.data?.list) ? res.data.list : []
  };
}

export async function fetchCoinGiveStatus(): Promise<CoinGiveStatus> {
  const { req } = apis.post({
    postData: {},
    remotePath: `${COIN_API_BASE}/give-status`
  });
  const res = (await req) as ApiResponse<CoinGiveStatus>;

  const status = res.data?.status;
  return {
    status: typeof status === 'number' && Number.isFinite(status) ? status : -1
  };
}

export async function fetchPointConsumeList(
  params: PointConsumeListParams = {}
): Promise<PointConsumeListResult> {
  const page = params.page ?? DEFAULT_POINT_CONSUME_PAGE;
  const pageSize = params.pageSize ?? params.pagesize ?? DEFAULT_POINT_CONSUME_PAGE_SIZE;
  const { req } = apis.post({
    postData: {
      page,
      pageSize,
      pagesize: pageSize
    },
    remotePath: `${AIPICTUREBOOK_API_BASE}/point-consume-list`
  });
  const res = (await req) as ApiResponse<BackendPointConsumeListResult>;
  const list = Array.isArray(res.data?.list) ? res.data.list : [];

  return {
    list,
    total: Number(res.data?.total ?? list.length) || list.length,
    currency: res.data?.currency ?? '',
    page: Number(res.data?.page ?? page) || page,
    pageSize: Number(res.data?.pageSize ?? res.data?.pagesize ?? pageSize) || pageSize
  };
}
